// extracted by mini-css-extract-plugin
module.exports = {"dealerResult":"DealerResult_dealerResult__xKccK","dealerName":"DealerResult_dealerName__wN_RX","dealerAddress":"DealerResult_dealerAddress__URI1B"};